/** @return {null|string} */
export default function formatPhoneNumber(phoneNumber) {
  const cleaned = (`${phoneNumber.number}`).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  return match
    ? `${match[1]}.${match[2]}.${match[3]}`
    : null;
}
